export default __webpack_public_path__ + "assets/862390a0f9d162ec382edbb2fba0cd0d.png";